import React from 'react';
import { Typography, Box } from '@kareo/design-system';
var FacesheetCardFooter = function (_a) {
    var text = _a.text;
    return (React.createElement(Box, { mt: 1 },
        React.createElement(Typography, { variant: "body2", color: "textSecondary", align: "center", component: "div" }, text)));
};
export default FacesheetCardFooter;
